import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ForWhomSection() {
  const items = ['Mulheres entre 40 e 65 anos', 'Quem sente a barriga aumentar ao longo do dia', 'Quem percebe retenção em mãos, pés, rosto ou pernas', 'Quem está na perimenopausa ou menopausa', 'Quem sente que dietas antigas não funcionam mais', 'Quem quer algo simples, prático e realista', 'Quem quer voltar a vestir suas roupas com mais conforto'];
  return <section className="py-16 bg-white" data-id="element-83">
      <div className="max-w-3xl mx-auto px-5 md:px-8" data-id="element-84">
        <div className="bg-brand-cream rounded-3xl p-8 md:p-12 border border-brand-sage/30 shadow-sm" data-id="element-85">
          <h2 className="text-3xl font-serif font-bold text-brand-dark mb-8 text-center" data-id="element-86">
            Para Quem É
          </h2>
          <ul className="space-y-4" data-id="element-87">
            {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-88">
                <div className="bg-brand-sage/50 p-1 rounded-full mr-4 flex-shrink-0 mt-0.5" data-id="element-89">
                  <CheckIcon className="w-5 h-5 text-brand-dark" data-id="element-90" />
                </div>
                <span className="text-brand-text text-lg" data-id="element-91">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}